module.exports = __webpack_public_path__ + "media/images/athletes/1982-d346b4f1d4f10ca25e52e44d33dc20f7.png";